export const QUIZ_DATA = [
    {
        quote: 'Two roads diverged in a wood and I — I took the one less traveled by, and that has made all the difference.',
        choices: ['Emily Dickinson', 'Robert Frost', 'T.S. Elliot', 'William Shakespear'],
        answer: 'Robert Frost'
    },    
    {
        quote: 'Your time is limited, so don\'t waste it living someone else\'s life. Don\'t be trapped by dogma – which is living with the results of other people\'s thinking.',
        choices: ['Jesus Christ', 'Marilyn Monroe', 'Steve Jobs', 'Albert Einstein'],
        answer: 'Steve Jobs'
    },
    {
        quote: 'In spite of everything I still believe that people are really good at heart.',
        choices: ['Viktor Frankl', 'Anne Frank', 'Nelson Mandela', 'Winston Churchill'],
        answer: 'Anne Frank'
    }, 
    {
        quote: 'I came, I saw, I conquered.',
        choices: ['Napolean Bonaparte', 'John Lennon', 'Barack Obama', 'Julius Caesar'],
        answer: 'Julius Caesar'
    },
    {
        quote: 'Darkness cannot drive out darkness; only light can do that. Hate cannot drive out hate, only love can do that.',
        choices: ['Martin Luther King', 'John F. Kennedy', 'Mahatma Ghandhi', 'Mother Teresa'],
        answer: 'Martin Luther King'
    },
    {
        quote: 'Life is what happens when you\'re busy making other plans.',
        choices: ['Allen Saunders', 'John Lennon', 'J.K. Rowling', 'Princess Diana'],
        answer: 'Allen Saunders'
    },
    {
        quote: 'The only thing we have to fear is fear itself.',
        choices: ['Teddy Roosevelt', 'Franklin D. Roosevelt', 'Neil Armstrong', 'Napolean Bonaparte'],
        answer: 'Franklin D. Roosevelt'
    },
    {
        quote: 'Better to die standing than to live on your knees.',
        choices: ['Teddy Roosevelt', 'Che Guevara', 'Emiliano Zapata', 'Muhammad Ali'],
        answer: 'Emiliano Zapata'
    },    
    {
        quote: 'When the whole world is silent, even one voice becomes powerful.',
        choices: ['Mother Teresa', 'Eleanor Roosevelt', 'Malala Yousafzai', 'Martin Luther King'],
        answer: 'Malala Yousafzai'
    },    
    {
        quote: 'There is not a liberal America and a conservative America. There is the United States of America. There is not a black America, a white America, a Latino America, an Asian America. There’s the United States of America.',
        choices: ['Ronald Reagan', 'Bill Clinton', 'Donald Trump', 'Barack Obama'],
        answer: 'Barack Obama'
    },          
]
